module.exports = __webpack_public_path__ + "img/ch4.76ec006b.jpeg";